// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"1ba87541","453":"819b3c5f"}[chunkId] + ".chunk.js";
};